<svg xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true" height="0" width="0">
	<defs>
		<style>
			.svg-path {
				fill: none;
				stroke: #242424;
				stroke-width: 1px;
			}
		</style>
		<symbol id="icon-flip" xmlns="http://www.w3.org/2000/svg" width="24.709" height="17.413">
			<path class="svg-path" d="M20.356 16.705v-13l-3-3h-8" />
			<path class="svg-path" d="M24.354 12.705l-4 4-4-4" />
			<path class="svg-path" d="M4.356.708v13l3 3h8" />
			<path class="svg-path" d="M.356 4.708l4-4 4 4" />
		</symbol>
		<symbol id="icon-rotate" xmlns="http://www.w3.org/2000/svg" width="22.859" height="19.004">
			<path class="svg-path" d="M9.5 18.5a9 9 0 119-9v3" />
			<path class="svg-path" d="M22.504 8.502l-4 4-4-4" />
		</symbol>
		<symbol id="icon-close" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
			<path stroke="currentColor" d="M1 1L17 17 M17 1 L1 17" />
		</symbol>
		<symbol
			id="icon-arrow"
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 18.707 14.707"
		>
			<path class="svg-path" d="M0 7.354h18M11 14.352l7-7-7-7" />
		</symbol>
		<symbol id="icon-facebook" xmlns="http://www.w3.org/2000/svg" width="12.995" height="25">
			<path
				fill="#242424"
				d="M8.436 25V13.6h3.829l.574-4.447h-4.4V6.318c0-1.286.357-2.164 2.2-2.164h2.351V.178A32.269 32.269 0 0 0 9.559.004c-3.4 0-5.724 2.071-5.724 5.874v3.276H0v4.447h3.839v11.4Z"
			/>
		</symbol>
		<symbol
			id="icon-instagram"
			xmlns="http://www.w3.org/2000/svg"
			width="27.249"
			height="27.254"
		>
			<g transform="translate(-304.244 -255.191)">
				<path
					fill="#242424"
					d="M317.869 257.65c3.637 0 4.068.014 5.505.08a7.546 7.546 0 012.531.469 4.511 4.511 0 012.582 2.586 7.538 7.538 0 01.469 2.531c.066 1.437.08 1.867.08 5.506s-.014 4.068-.08 5.505a7.547 7.547 0 01-.469 2.531 4.514 4.514 0 01-2.583 2.58 7.543 7.543 0 01-2.531.47c-1.436.065-1.867.079-5.5.079s-4.069-.014-5.505-.079a7.543 7.543 0 01-2.531-.47 4.513 4.513 0 01-2.586-2.585 7.547 7.547 0 01-.469-2.531c-.066-1.438-.08-1.868-.08-5.506s.014-4.069.08-5.505a7.548 7.548 0 01.469-2.532 4.513 4.513 0 012.586-2.585 7.542 7.542 0 012.531-.469c1.437-.066 1.867-.08 5.506-.08m0-2.454c-3.7 0-4.165.015-5.617.081a10 10 0 00-3.308.634 6.967 6.967 0 00-3.985 3.985 10.019 10.019 0 00-.633 3.307c-.067 1.458-.082 1.921-.082 5.622s.016 4.164.082 5.617a10.014 10.014 0 00.633 3.307 6.964 6.964 0 003.985 3.985 10 10 0 003.308.634c1.452.066 1.917.082 5.617.082s4.164-.016 5.617-.082a10 10 0 003.307-.634 6.964 6.964 0 003.985-3.985 9.964 9.964 0 00.633-3.307c.067-1.453.082-1.917.082-5.617s-.016-4.164-.082-5.617a9.969 9.969 0 00-.633-3.307 6.967 6.967 0 00-3.985-3.985 10 10 0 00-3.307-.634c-1.453-.066-1.917-.081-5.617-.081z"
				/>
				<path
					fill="#242424"
					d="M317.867 261.824a7 7 0 107 7 7 7 0 00-7-7zm0 11.538a4.542 4.542 0 114.542-4.542 4.542 4.542 0 01-4.542 4.542z"
				/>
				<circle
					fill="#242424"
					cx="1.635"
					cy="1.635"
					r="1.635"
					transform="translate(323.506 259.912)"
				/>
			</g>
		</symbol>
		<symbol id="icon-twitter" xmlns="http://www.w3.org/2000/svg" width="23.207" height="19">
			<path
				fill="#242424"
				d="M22.681 2.193a8.8 8.8 0 0 1-1.122.409A4.961 4.961 0 0 0 22.568.825a.374.374 0 0 0-.547-.436 8.833 8.833 0 0 1-2.611 1.032 4.984 4.984 0 0 0-8.469 3.561 5.082 5.082 0 0 0 .041.644A12.754 12.754 0 0 1 2.228.981a.374.374 0 0 0-.614.048 4.989 4.989 0 0 0 .511 5.734 4.22 4.22 0 0 1-.667-.3.374.374 0 0 0-.558.321v.067a5 5 0 0 0 2.439 4.284 4.435 4.435 0 0 1-.379-.055.374.374 0 0 0-.427.482A4.98 4.98 0 0 0 6.184 14.9a8.814 8.814 0 0 1-4.711 1.345 9.014 9.014 0 0 1-1.055-.062.374.374 0 0 0-.246.687A13.435 13.435 0 0 0 7.437 19a12.925 12.925 0 0 0 10.014-4.4 13.941 13.941 0 0 0 3.47-9.086c0-.137 0-.275-.006-.412a9.685 9.685 0 0 0 2.229-2.361.374.374 0 0 0-.463-.55"
			/>
		</symbol>
	</defs>
</svg>
